import humanizeString from 'humanize-string'

import { OptionsProps } from '../components/Filters/Filters.types'

export const getLabelsForSelectedOptions = (
  selectedOptions: string[],
  options: OptionsProps<string>[],
) => {
  const optionIndexByValue = options.reduce<Record<string, number>>((output, item, index) => {
    return { ...output, [item.value]: index }
  }, {})

  const optionLabelByValue = options.reduce<Record<string, string>>((output, item) => {
    return {
      ...output,
      [item.value]: typeof item.label === 'string' ? item.label : humanizeString(item.value),
    }
  }, {})

  return [...selectedOptions]
    .sort((a, b) => {
      return (optionIndexByValue[a] ?? options.length) - (optionIndexByValue[b] ?? options.length)
    })
    .map(option => optionLabelByValue[option] ?? option)
}
